import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from "moment-timezone";

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(private readonly snackBar: MatSnackBar) { }

  showMessageNotification(message: string, type: string, action = ''): void {
    this.snackBar.open(message, action, {
      duration: action ? null : 4000,
      panelClass: type === 'danger' ? ['red-snackbar'] : ['green-snackbar'],
      horizontalPosition: 'right',
      verticalPosition: 'top'
    });
  }

  getMaxMinYear(startDate): { min: Date, max: Date } {
    if (startDate) {
      return {
        min: new Date(startDate),
        max: new Date(`12/31/${new Date(startDate).getFullYear()}`)
      };
    }

    return {
      min: new Date(`1/1/${new Date().getFullYear()}`),
      max: new Date(`12/31/${new Date().getFullYear()}`)
    };
  }

  dateFormatCST(date: string): string {
    const utcDate = moment.utc(date, 'YYYYMMDD HH:mm:ss');
    const displayEST = utcDate.clone().local();
    return displayEST.format('MM/DD/YYYY HH:mm:ss');
  }

  downloadDocument(base64: string, documentName: string): void {
    const linkSource = `data:application/pdf;base64,${base64}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = documentName;
    downloadLink.click();
  }

  getDomIntDesc(code: string): string {
    let desc: string;

    switch (code?.trim()) {
      case 'A':
        desc = 'All';
        break;
      case 'D':
        desc = 'Domestic';
        break;
      case 'I':
        desc = 'International';
        break;
      default:
        desc = '';
        break;
    }

    return desc;
  }

  isEmailValid(email: string): boolean {
    const regexEmail = '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$';
    return new RegExp(regexEmail).test(email);
  }

}
